@if (isBrowser && fixed) {
  <nz-affix #affix [nzOffsetTop]="fixedOffsetTop">
    <ng-template [ngTemplateOutlet]="phTpl" />
  </nz-affix>
} @else {
  <ng-template [ngTemplateOutlet]="phTpl" />
}
<ng-template #phTpl>
  <div class="page-header" [class.page-header-rtl]="dir === 'rtl'">
    <div [class.page-header__wide]="wide">
      <nz-skeleton
        [nzLoading]="loading"
        [nzTitle]="false"
        [nzActive]="true"
        [nzParagraph]="{ rows: 3 }"
        [nzAvatar]="{ size: 'large', shape: 'circle' }"
        class="d-block"
      >
        @if (breadcrumb) {
          <ng-template [ngTemplateOutlet]="breadcrumb" />
        } @else {
          @if (paths && paths.length > 0) {
            <nz-breadcrumb>
              @for (i of paths; track $index) {
                <nz-breadcrumb-item>
                  @if (i.link) {
                    <a [routerLink]="i.link">{{ i.title }}</a>
                  } @else {
                    {{ i.title }}
                  }
                </nz-breadcrumb-item>
              }
            </nz-breadcrumb>
          }
        }
        <div class="page-header__detail">
          @if (logo) {
            <div class="page-header__logo">
              <ng-template [ngTemplateOutlet]="logo" />
            </div>
          }
          <div class="page-header__main">
            <div class="page-header__row">
              @if (_titleVal || _titleTpl) {
                <h1 class="page-header__title">
                  @if (_titleTpl) {
                    <ng-template [ngTemplateOutlet]="_titleTpl" />
                  } @else {
                    {{ _titleVal }}
                    @if (titleSub) {
                      <small>
                        <ng-container *nzStringTemplateOutlet="titleSub">{{ titleSub }}</ng-container>
                      </small>
                    }
                  }
                </h1>
              }
              @if (action) {
                <div class="page-header__action">
                  <ng-template [ngTemplateOutlet]="action" />
                </div>
              }
            </div>
            <div class="page-header__row">
              <div class="page-header__desc" (cdkObserveContent)="checkContent()" #conTpl>
                <ng-content />
                <ng-template [ngTemplateOutlet]="content!" />
              </div>
              @if (extra) {
                <div class="page-header__extra">
                  <ng-template [ngTemplateOutlet]="extra" />
                </div>
              }
            </div>
          </div>
        </div>
        <ng-template [ngTemplateOutlet]="tab!" />
      </nz-skeleton>
    </div>
  </div>
</ng-template>
